module.exports = __webpack_public_path__ + "static/media/loading.27fc27b6.svg";